export default __webpack_public_path__ + "img/laptop.c725911f.svg";